(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kom-product-premium"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kom-product-polish')) {
  customElements.define('kom-product-polish', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.section = this.closest('.shopify-section');
      this.polish = this.polish.bind(this);
      this.observer = new MutationObserver(this.polish);
      this.observer.observe(this.section, {childList: true, subtree: true});
      this.guideObserver = new MutationObserver(this.polish);
      this.guideObserver.observe(document.body, {childList: true, subtree: true});
      this.guideTimeout = setTimeout(() => this.guideObserver.disconnect(), 15000);
      this.section.addEventListener('click', event => {
        const button = event.target.closest('.kom-size-guide');
        if (!button) return;
        const trigger = document.querySelector('#sizefox-container [role="button"]');
        if (trigger) trigger.click();
      }, {signal:this.controller.signal});
      this.polish();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.guideObserver?.disconnect();
      clearTimeout(this.guideTimeout);
    }
    polish() {
      const trigger = document.querySelector('#sizefox-container [role="button"]');
      if (trigger) this.section.querySelectorAll('.kom-size-guide[hidden]').forEach(button => button.hidden = false);
      const link = this.section.querySelector('.kom-rating-link');
      const overall = this.section.querySelector('.ezrv-widget_overall_rating');
      if (link && overall && !link.querySelector('.kom-rating-summary')) {
        const labels = overall.querySelectorAll('.ezrv-widget_overall_rating_content');
        const rating = labels[0]?.textContent.match(/[\d.,]+/)?.[0];
        const count = labels[1]?.textContent.match(/\d+/)?.[0];
        if (rating && count) {
          const summary = document.createElement('span');
          summary.className = 'kom-rating-summary';
          summary.textContent = this.dataset.ratingTemplate.replace('[rating]',rating).replace('[count]',count);
          link.append(summary);
          link.classList.add('kom-rating-ready');
        }
      }
      const gallery = this.section.querySelector('product-gallery');
      if (gallery && !gallery.querySelector('.kom-gallery-hint')) {
        const hint = document.createElement('p');
        hint.className = 'kom-gallery-hint';
        hint.textContent = this.dataset.galleryHint;
        gallery.append(hint);
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kom-reviews-premium"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kom-reviews-premium')) {
 customElements.define('kom-reviews-premium',class extends HTMLElement {
  connectedCallback() {
   this.section=this.closest('.shopify-section');
   if(!this.section)return;
   this.observer=new MutationObserver(()=>this.enhance());
   this.observer.observe(this.section,{childList:true,subtree:true});
   this.enhance();
  }
  disconnectedCallback(){this.observer?.disconnect();}
  enhance(){
   const root=this.section.querySelector('#ezrv-root');
   if(!root)return;
   const histogram=root.querySelector('.ezrv-widget_rating_count');
   if(histogram&&!histogram.closest('details')){
    const details=document.createElement('details');details.className='kom-review-breakdown';
    const summary=document.createElement('summary');summary.textContent=this.dataset.breakdown;
    details.append(summary);histogram.before(details);details.append(histogram);
   }
   root.querySelectorAll('.ezrv-widget_review_listing_row').forEach(row=>{
    if(row.dataset.komReviewReady)return;
    row.dataset.komReviewReady='true';
    const ratings=row.querySelector('.ezrv-widget_review_rating_option');
    if(ratings&&ratings.children.length>1){
     const details=document.createElement('details');details.className='kom-review-extra';
     const summary=document.createElement('summary');summary.textContent=this.dataset.details;details.append(summary);
     [...ratings.children].slice(1).forEach(child=>details.append(child));row.append(details);
    }
   });
   const list=root.querySelector('.ezrv-widget_review_listings');
   if(list){
    if(!list.dataset.komCarousel){
     list.dataset.komCarousel='true';list.tabIndex=0;list.setAttribute('role','region');list.setAttribute('aria-label',this.dataset.region);
     const hint=document.createElement('p');hint.className='kom-review-swipe';hint.textContent=this.dataset.swipe;list.before(hint);
    }
    const hint=root.querySelector('.kom-review-swipe');if(hint)hint.hidden=list.children.length<2;
    if(this.firstCard!==list.firstElementChild){this.firstCard=list.firstElementChild;list.scrollLeft=0;}
   }
   const labels=['first','previous','next','last'];
   root.querySelectorAll('.ezrv-pagination-link').forEach((link,index)=>{
    if(!link.dataset.komPage){
     link.dataset.komPage='true';link.setAttribute('role','button');link.tabIndex=0;
     link.setAttribute('aria-label',this.dataset[labels[index]]||this.dataset.next);
     link.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();link.click();}});
    }
   });
  }
 });
}
  } catch(e) { console.error(e); }
})();

})();
